import Axios from 'axios'
import Config from '../config'


const query = `
query ($page:Int, $perPage:Int, $search:String) { # Define which variables will be used in the query (id)
  Page(page:$page, perPage:$perPage){
    pageInfo{
        lastPage
    }
    media(search:$search, type:ANIME){
        id, 
        title{
            romaji
            english
        }
        format
    }
  }
}
`;


function searchMedia({page, perPage}, search) {
    return Axios.post(Config.anilistApiUrl, JSON.stringify({
            query: query,
            variables: {page: page, perPage: perPage, search: search}
        }),
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => {
        return {
            results: Object.values(response.data.data.Page.media).map(x => {
                return {
                    id: x.id,
                    title: x.title.romaji,
                    format: x.format

                }
            }),
            lastPage: response.data.data.Page.pageInfo.lastPage
        }});
}


export const MediaDialogService = {
    searchMedia
};